<template>
  <RefBody/>
</template>

<script>
// @ is an alias to /src
import RefBody from '@/components/RefBody.vue'

export default {
  name: 'RefView',
  components: {
    RefBody
  }
}
</script>
